import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import $ from "jquery";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import validator from "validator";
import { format } from "date-fns";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, ecommerceapiUrl, masterheaderconfig } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, isSingleSelect, decodeValue, passwordChar, uploadFile, removeFile } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Switch from "react-switch";
import { supabaseReservation, epicengageSupabase, epicengageSupabasev1 } from "../../../integrations/supabase/client";
import { supabaseEpicSocial } from "../../../integrations/supabase/EpicSocialClient";
var todayDate = new Date();
class Clientform extends Component {
  constructor(props) {
    super(props);
    console.log(this.props, "this.props.paramsthis.props.params");
    this.state = {
      editID: this.props.params?.clientID || "",
      pageloading: false,
      clientdata: {
        companyName: "",
        companyUsername: "",
        companyPassword: "",
        companyCPassword: "",
        companyEmail: "",
        companyContactNumber: "",
        companyWebSite: "",
        companyCategoryID: [],
        companyCountry: "",
        companyCurrency: "",
        companyLanguage: "",
        companyDateFormat: "",
        companyTimeFormat: "",
        companyEarnPointPercentage: null,
        companyLogo: "",
        companyAvailability: [],
        companyPlans: [],
        companyLiveStatus: false,
        companyStatus: "",
        companyMerchantsType: { label: "Complete", value: "1" },
        companyEnableSubscription: false,
        companyEnableEmailCampaign: false,
        companyEnableSMSCampaign: false,
        companyTwilioFromName: "",
        companyEnableWhatsappCampaign: false,
        companyTwilioWhatsappSenderID: "",
        companyTwilioWhatsappTotalMsg: 0,
        companyTwilioWhatsappUsedMsg: 0,
        companyTwilioWhatsappAvailableMsg: 0,
        companyTwilioWhatsappMsgLastTopup: 0,
        companyTwilioWhatsappMsgLastTopupDate: "",
        companyTwilioWhatsappMsgTopup: 0,
        companyUniqueIDTxt: "",
        companyEnableTax: false,
        companySMSBalance: "",
        companyEnableMembership: false,
        companyenablemanualpayment: false,
        companyEnablemswipe: false,
        companymswipemode: false,
        companymswiperefid: "",
        companymswipecustCode: "",
        companymswipeUserName: "",
        companymswipeuserPasssword: "",
        companyenablereddot: false,
        companyreddotmodemv3ds: false,
        companyreddotmidmv3ds: "",
        companyreddotsecretKeymv3ds: "",
        companyreddotmodeamex3ds: false,
        companyreddotmidamex3ds: "",
        companyreddotsecretKeyamex3ds: "",
        companyreddotmodemvwithout3ds: false,
        companyreddotmidmvwithout3ds: "",
        companyreddotsecretKeymvwithout3ds: "",
        companyreddotmodeamexwithout3ds: false,
        companyreddotmidamexwithout3ds: "",
        companyreddotsecretKeyamexwithout3ds: "",
        companyreddotmodeapplepay: false,
        companyreddotmidapplepay: "",
        companyreddotsecretKeyapplepay: "",
        companyreddotmodegooglepay: false,
        companyreddotmidgooglepay: "",
        companyreddotsecretKeygooglepay: "",
        companyreddotmodeatome: false,
        companyreddotmidatome: "",
        companyreddotsecretKeyatome: "",
        companyreddotmodepaynow: false,
        companyreddotmidpaynow: "",
        companyreddotsecretKeypaynow: "",
        companyreddotmodegrabpay: false,
        companyreddotmidgrabpay: "",
        companyreddotsecretKeygrabpay: "",
        companyEnableRapyd: false,
        companyrapydmode: false,
        companyrapydaccesskey: "",
        companyrapydsecretkey: "",

        companyEnableStripe: false,
        companyStripeSecretKey: "",
        companyStripePublicKey: "",

        companyEnableOmise: false,
        companyEnableOmisePayNow: false,
        companyOmiseSecretKey: "",
        companyOmisePublicKey: "",

        companyTelegramchatID: "",
        companyAllowAssignVoucher: false,
        companyEnableGoogleWallet: false,
        companyEnableAppleWallet: false,

        companyEnableMenu: false,
        companyEnableTAT: false,
        companyEnableZoneValueBaseDeliveryCharge: false,
        companyEnableGuestCheckout: false,
        companyEnableMaintenanceMode: false,
        companyEnableAdditionalCharge: false,

        companyEnableSpinWheel: false,
        companyEnableScratch: false,
        companyEnablePromocode: false,
        companyEnableLoyalty: false,
        companyEnableAscentisCRM: false,
        companyEnableNewSignupPromocode: false,
        companyEnableHoliday: false,
        companyEnableOrderCount: false,
        companyEnableHighlightProduct: false,
        companyEnableProductTimeAvailability: false,
        companyEnableProductspecialDays: false,
        companyEnableProductRating: false,
        companyEnableStock: false,
        companyEnableDeliveryAutoCreate: false,
        companyEnableDeliveryFeeAuto: false,
        companyEnableLalamove: false,
        companyLalamovemode: false,
        companyLalamoveKey: "",
        companyLalamoveSecretKey: "",
        companyLalamoveCountry: "",
        companyLalamoveserviceType: "",
        companyEnableReservation: false,
        companysupabaseReservationID: "",
        companysupabaseReservationUserName: "",
        companysupabaseReservationPassword: "",
        companyEnableEpicEngage: false,
        companysupabaseEngageID: "",
        companysupabaseEngageUserName: "",
        companysupabaseEngagePassword: "",

        companyEnableEpicEngagev1: false,
        companysupabaseEngageIDv1: "",
        companysupabaseEngagev1UserName: "",
        companysupabaseEngagev1Password: "",


        companyEnableEpicSocial: false,
        companysupabaseEpicSocialID: "",
        companysupabaseEpicSocialUserName: "",
        companysupabaseEpicSocialPassword: "",

        companyEnableCatering: false,
      },
      btndisabled: false,
      loading: true,
      checked: true,
      categoryList: [],
      countryList: [],
      currencyList: [],
      languageList: [],
      formpost: [],
      companyDetail: [],
      availabiltyList: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.companycategoryList();
    this.loadCountyList();
    this.loadCurrency();
    this.loadLanguage();
    this.loadAvailabilty();

    if (this.state.editID !== "") {
      var params = {
        url: `${apiUrl}company/details/${this.state.editID}`,
        type: "master",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success");
          this.props.navigate("/masterpanel/client");
        } else {
          showAlert("Error", errMsg, "error");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          try {
            var result = nextProps.detaildata[0].result;
            var companyStatus_txt = "Inactive";
            if (result.companyStatus === "A") {
              companyStatus_txt = "Active";
            } else if (result.companyStatus === "I") {
              companyStatus_txt = "Inactive";
            } else if (result.companyStatus === "D") {
              companyStatus_txt = "Deleted";
            }
            var status =
              result.companyStatus !== "" && result.companyStatus !== null
                ? {
                    label: companyStatus_txt,
                    value: result.companyStatus,
                  }
                : "";
            var companymerchantstype = { label: "Complete", value: "1" };
            if (result.companyMerchantsType === "1") {
              companymerchantstype = { label: "Complete", value: "1" };
            } else if (result.companyMerchantsType === "2") {
              companymerchantstype = { label: "Voucher Only", value: "2" };
            }
            var companyreddotmidmv3ds = result?.companyreddotmidmv3ds || "";
            var companyreddotsecretKeymv3ds = result?.companyreddotsecretKeymv3ds || "";
            var companyreddotmidamex3ds = result?.companyreddotmidamex3ds || "";
            var companyreddotsecretKeyamex3ds = result?.companyreddotsecretKeyamex3ds || "";
            var companyreddotmidmvwithout3ds = result?.companyreddotmidmvwithout3ds || "";
            var companyreddotsecretKeymvwithout3ds = result?.companyreddotsecretKeymvwithout3ds || "";
            var companyreddotmidamexwithout3ds = result?.companyreddotmidamexwithout3ds || "";
            var companyreddotsecretKeyamexwithout3ds = result?.companyreddotsecretKeyamexwithout3ds || "";
            var companyreddotmidapplepay = result?.companyreddotmidapplepay || "";
            var companyreddotsecretKeyapplepay = result?.companyreddotsecretKeyapplepay || "";
            var companyreddotmidgooglepay = result?.companyreddotmidgooglepay || "";
            var companyreddotsecretKeygooglepay = result?.companyreddotsecretKeygooglepay || "";
            var companyreddotmidatome = result?.companyreddotmidatome || "";
            var companyreddotsecretKeyatome = result?.companyreddotsecretKeyatome || "";
            var companyreddotmidpaynow = result?.companyreddotmidpaynow || "";
            var companyreddotsecretKeypaynow = result?.companyreddotsecretKeypaynow || "";
            var companyreddotmidgrabpay = result?.companyreddotmidgrabpay || "";
            var companyreddotsecretKeygrabpay = result?.companyreddotsecretKeygrabpay || "";
            var companymswipeuserPasssword = result?.companymswipeuserPasssword || "";
            var companyrapydaccesskey = result?.companyrapydaccesskey ?? "";
            var companyrapydsecretkey = result?.companyrapydsecretkey ?? "";
            const companyStripeSecretKey = result?.companyStripeSecretKey ?? "";
            const companyStripePublicKey = result?.companyStripePublicKey ?? "";
            const companyOmiseSecretKey = result?.companyOmiseSecretKey ?? "";
            const companyOmisePublicKey = result?.companyOmisePublicKey ?? "";

            const companyPlans = result?.companyPlans ?? "";
            const companyDateFormat = result?.companyDateFormat ?? "";
            const companyTimeFormat = result?.companyTimeFormat ?? "";
            const companyAvailability = result?.companyAvailability ?? "";

            const companyLalamoveKey = result?.companyLalamoveKey ?? "";
            const companyLalamoveSecretKey = result?.companyLalamoveSecretKey ?? "";
            const companyLalamoveserviceType = result?.companyLalamoveserviceType ?? "";

            var clientupdatedata = {
              companyName: result.companyName,
              companyUsername: result.companyUsername,
              companyPassword: "",
              companyCPassword: "",
              companyEmail: result.companyEmail,
              companyContactNumber: result?.companyContactNumber ?? "",
              companyWebSite: result?.companyWebSite ?? "",
              companyCountry: {
                label: result.companyCountryName,
                value: result.companyCountry,
              },
              companyCategoryID: result?.companyCategoryList ?? [],
              companyCurrency:
                result.companyCurrency !== ""
                  ? {
                      label: result.companyCurrency,
                      value: result.companyCurrency,
                    }
                  : "",
              companyLanguage: result?.companyLanguage
                ? {
                    label: result?.companyLanguageName,
                    value: result?.companyLanguage,
                  }
                : "",
              companyDateFormat:
                companyDateFormat !== "" && companyDateFormat !== null
                  ? {
                      label: format(todayDate, companyDateFormat),
                      value: companyDateFormat,
                    }
                  : "",
              companyTimeFormat:
                companyTimeFormat !== "" && companyTimeFormat !== null
                  ? {
                      label: format(todayDate, companyTimeFormat),
                      value: companyTimeFormat,
                    }
                  : "",
              companyEarnPointPercentage: result.companyEarnPointPercentage ?? null,
              companyLogo: result?.companyLogo || "",
              companyPlans: companyPlans !== "" && companyPlans !== null ? companyPlans.split(",") : [],
              companyAvailability: companyAvailability !== null && companyAvailability !== "" ? companyAvailability.split(",") : [],
              companyStatus: status,
              companyLiveStatus: result.companyLiveStatus ?? false,
              companyMerchantsType: companymerchantstype,
              companyEnableSubscription: result?.companyEnableSubscription || false,
              companyEnableEmailCampaign: result?.companyEnableEmailCampaign || false,
              companyEnableSMSCampaign: result?.companyEnableSMSCampaign || false,
              companyTwilioFromName: result?.companyTwilioFromName || "",
              companyEnableWhatsappCampaign: result?.companyEnableWhatsappCampaign || false,
              companyTwilioWhatsappSenderID: result?.companyTwilioWhatsappSenderID ?? "",
              companyTwilioWhatsappTotalMsg: result?.companyTwilioWhatsappTotalMsg ?? 0,
              companyTwilioWhatsappUsedMsg: result?.companyTwilioWhatsappUsedMsg ?? 0,
              companyTwilioWhatsappAvailableMsg: result?.companyTwilioWhatsappAvailableMsg ?? 0,
              companyTwilioWhatsappMsgLastTopup: result?.companyTwilioWhatsappMsgLastTopup ?? 0,
              companyTwilioWhatsappMsgLastTopupDate: result?.companyTwilioWhatsappMsgLastTopupDate ?? "",
              companyTwilioWhatsappMsgTopup: 0,
              companyUniqueIDTxt: result?.companyUniqueID || "",
              companyEnableTax: result?.companyEnableTax || false,
              companySMSBalance: result?.companySMSBalance || "",
              companyEnableMembership: result?.companyEnableMembership || false,
              companyenablemanualpayment: result?.companyenablemanualpayment ? Boolean(result?.companyenablemanualpayment) : false,
              companyEnablemswipe: result?.companyEnablemswipe ? Boolean(result?.companyEnablemswipe) : false,
              companymswipemode: result?.companymswipemode === 1 ? true : false,
              companymswiperefid: result?.companymswiperefid || "",
              companymswipecustCode: result?.companymswipecustCode || "",
              companymswipeUserName: result?.companymswipeUserName || "",
              companymswipeuserPasssword: decodeValue(companymswipeuserPasssword),
              companyenablereddot: result?.companyenablereddot || false,
              companyreddotmodemv3ds: result?.companyreddotmodemv3ds || false,
              companyreddotmidmv3ds: decodeValue(companyreddotmidmv3ds),
              companyreddotsecretKeymv3ds: decodeValue(companyreddotsecretKeymv3ds),
              companyreddotmodeamex3ds: result?.companyreddotmodeamex3ds ? Boolean(result?.companyreddotmodeamex3ds) : false,
              companyreddotmidamex3ds: decodeValue(companyreddotmidamex3ds),
              companyreddotsecretKeyamex3ds: decodeValue(companyreddotsecretKeyamex3ds),
              companyreddotmodemvwithout3ds: result?.companyreddotmodemvwithout3ds ? Boolean(result?.companyreddotmodemvwithout3ds) : false,
              companyreddotmidmvwithout3ds: decodeValue(companyreddotmidmvwithout3ds),
              companyreddotsecretKeymvwithout3ds: decodeValue(companyreddotsecretKeymvwithout3ds),
              companyreddotmodeamexwithout3ds: result?.companyreddotmodeamexwithout3ds ? Boolean(result?.companyreddotmodeamexwithout3ds) : false,
              companyreddotmidamexwithout3ds: decodeValue(companyreddotmidamexwithout3ds),
              companyreddotsecretKeyamexwithout3ds: decodeValue(companyreddotsecretKeyamexwithout3ds),
              companyreddotmodeapplepay: result?.companyreddotmodeapplepay ? Boolean(result?.companyreddotmodeapplepay) : false,
              companyreddotmidapplepay: decodeValue(companyreddotmidapplepay),
              companyreddotsecretKeyapplepay: decodeValue(companyreddotsecretKeyapplepay),
              companyreddotmodegooglepay: result?.companyreddotmodegooglepay ? Boolean(result?.companyreddotmodegooglepay) : false,
              companyreddotmidgooglepay: decodeValue(companyreddotmidgooglepay),
              companyreddotsecretKeygooglepay: decodeValue(companyreddotsecretKeygooglepay),
              companyreddotmodeatome: result?.companyreddotmodeatome ? Boolean(result?.companyreddotmodeatome) : false,
              companyreddotmidatome: decodeValue(companyreddotmidatome),
              companyreddotsecretKeyatome: decodeValue(companyreddotsecretKeyatome),
              companyreddotmodepaynow: result?.companyreddotmodepaynow ? Boolean(result?.companyreddotmodepaynow) : false,
              companyreddotmidpaynow: decodeValue(companyreddotmidpaynow),
              companyreddotsecretKeypaynow: decodeValue(companyreddotsecretKeypaynow),
              companyreddotmodegrabpay: result?.companyreddotmodegrabpay ? Boolean(result?.companyreddotmodegrabpay) : false,
              companyreddotmidgrabpay: decodeValue(companyreddotmidgrabpay),
              companyreddotsecretKeygrabpay: decodeValue(companyreddotsecretKeygrabpay),
              companyEnableRapyd: result?.companyEnableRapyd ? Boolean(result?.companyEnableRapyd) : false,
              companyrapydmode: result?.companyrapydmode || false,
              companyrapydaccesskey: decodeValue(companyrapydaccesskey),
              companyrapydsecretkey: decodeValue(companyrapydsecretkey),
              companyEnableStripe: result?.companyEnableStripe ? Boolean(result?.companyEnableStripe) : false,
              companyStripeSecretKey: decodeValue(companyStripeSecretKey),
              companyStripePublicKey: decodeValue(companyStripePublicKey),

              companyEnableOmise: result?.companyEnableOmise ? Boolean(result?.companyEnableOmise) : false,
              companyEnableOmisePayNow: result?.companyEnableOmisePayNow ? Boolean(result?.companyEnableOmisePayNow) : false,
              companyOmiseSecretKey: decodeValue(companyOmiseSecretKey),
              companyOmisePublicKey: decodeValue(companyOmisePublicKey),

              companyTelegramchatID: result?.companyTelegramchatID ?? "",
              companyAllowAssignVoucher: result?.companyAllowAssignVoucher ? Boolean(result?.companyAllowAssignVoucher) : false,
              companyEnableGoogleWallet: result?.companyEnableGoogleWallet ? Boolean(result?.companyEnableGoogleWallet) : false,
              companyEnableAppleWallet: result?.companyEnableAppleWallet ? Boolean(result?.companyEnableAppleWallet) : false,

              companyEnableMenu: result?.companyEnableMenu ? Boolean(result?.companyEnableMenu) : false,
              companyEnableTAT: result?.companyEnableTAT ? Boolean(result?.companyEnableTAT) : false,
              companyEnableZoneValueBaseDeliveryCharge: result?.companyEnableZoneValueBaseDeliveryCharge ? Boolean(result?.companyEnableZoneValueBaseDeliveryCharge) : false,
              companyEnableGuestCheckout: result?.companyEnableGuestCheckout ? Boolean(result?.companyEnableGuestCheckout) : false,
              companyEnableMaintenanceMode: result?.companyEnableMaintenanceMode ? Boolean(result?.companyEnableMaintenanceMode) : false,
              companyEnableAdditionalCharge: result?.companyEnableAdditionalCharge ? Boolean(result?.companyEnableAdditionalCharge) : false,
              companyEnableSpinWheel: result?.companyEnableSpinWheel ? Boolean(result?.companyEnableSpinWheel) : false,
              companyEnableScratch: result?.companyEnableScratch ? Boolean(result?.companyEnableScratch) : false,
              companyEnablePromocode: result?.companyEnablePromocode ? Boolean(result?.companyEnablePromocode) : false,
              companyEnableLoyalty: result?.companyEnableLoyalty ? Boolean(result?.companyEnableLoyalty) : false,
              companyEnableAscentisCRM: result?.companyEnableAscentisCRM ? Boolean(result?.companyEnableAscentisCRM) : false,
              companyEnableNewSignupPromocode: result?.companyEnableNewSignupPromocode ? Boolean(result?.companyEnableNewSignupPromocode) : false,
              companyEnableHoliday: result?.companyEnableHoliday ? Boolean(result?.companyEnableHoliday) : false,
              companyEnableOrderCount: result?.companyEnableOrderCount ? Boolean(result?.companyEnableOrderCount) : false,
              companyEnableHighlightProduct: result?.companyEnableHighlightProduct ? Boolean(result?.companyEnableHighlightProduct) : false,
              companyEnableProductTimeAvailability: result?.companyEnableProductTimeAvailability ? Boolean(result?.companyEnableProductTimeAvailability) : false,
              companyEnableProductspecialDays: result?.companyEnableProductspecialDays ? Boolean(result?.companyEnableProductspecialDays) : false,
              companyEnableProductRating: result?.companyEnableProductRating ? Boolean(result?.companyEnableProductRating) : false,
              companyEnableStock: result?.companyEnableStock ? Boolean(result?.companyEnableStock) : false,

              companyEnableLalamove: result?.companyEnableLalamove ? Boolean(result?.companyEnableLalamove) : false,
              companyLalamovemode: result?.companyLalamovemode ? Boolean(result?.companyLalamovemode) : false,
              companyLalamoveKey: decodeValue(companyLalamoveKey),
              companyLalamoveSecretKey: decodeValue(companyLalamoveSecretKey),
              companyLalamoveCountry: result?.companyLalamoveCountry ?? "",
              companyLalamoveserviceType: companyLalamoveserviceType !== "" ? { label: companyLalamoveserviceType, value: companyLalamoveserviceType } : "",
              companyEnableDeliveryFeeAuto: result?.companyEnableDeliveryFeeAuto ? Boolean(result?.companyEnableDeliveryFeeAuto) : false,
              companyEnableDeliveryAutoCreate: result?.companyEnableDeliveryAutoCreate ? Boolean(result?.companyEnableDeliveryAutoCreate) : false,
              companyEnableReservation: result?.companyEnableReservation ? Boolean(result?.companyEnableReservation) : false,
              companysupabaseReservationID: result?.companysupabaseReservationID || "",
              companysupabaseReservationUserName: result?.companysupabaseReservationUserName || "",
              companysupabaseReservationPassword: result?.companysupabaseReservationPassword || "",
              companyEnableEpicEngage: result?.companyEnableEpicEngage ? Boolean(result?.companyEnableEpicEngage) : false,
              companysupabaseEngageID: result?.companysupabaseEngageID || "",
              companysupabaseEngageUserName: result?.companysupabaseEngageUserName || "",
              companysupabaseEngagePassword: result?.companysupabaseEngagePassword || "",

              companyEnableEpicEngagev1: result?.companyEnableEpicEngagev1 ? Boolean(result?.companyEnableEpicEngagev1) : false,
              companysupabaseEngageIDv1: result?.companysupabaseEngageIDv1 || "",
              companysupabaseEngagev1UserName: result?.companysupabaseEngagev1UserName || "",
              companysupabaseEngagev1Password: result?.companysupabaseEngagev1Password || "",


              companyEnableEpicSocial: result?.companyEnableEpicSocial ? Boolean(result?.companyEnableEpicSocial) : false,
              companysupabaseEpicSocialID: result?.companysupabaseEpicSocialID || "",
              companysupabaseEpicSocialUserName: result?.companysupabaseEpicSocialUserName || "",
              companysupabaseEpicSocialPassword: result?.companysupabaseEpicSocialPassword || "",

              companyEnableCatering: result?.companyEnableCatering ? Boolean(result?.companyEnableCatering) : false,
              
            };
            this.setState({ clientdata: clientupdatedata, pageloading: false });
          } catch (e) {
            console.log(e);
          }
        } else {
          showAlert("Error", "Invalid Company", "error");
        }
      });
    }
  }

  handleSignup = async () => {
    try {
      showLoader("registerreservation");
      const brandName = this.state.clientdata.companyName;
      const fullName = this.state.clientdata.companyName;
      const signupEmail = this.state.clientdata.companyEmail;
      const signupPassword = this.generateRandomString(12);

      // 1. Sign up the user
      const { data: authData, error: authError } = await supabaseReservation.auth.signUp({
        email: signupEmail,
        password: signupPassword,
      });

      if (authError) throw authError;
      if (!authData.user) throw new Error("User creation failed");

      // 2. Use database function to create account, profile, and config atomically
      // This bypasses RLS timing issues during signup
      const { error: setupError } = await supabaseReservation.rpc("create_account_for_user", {
        _user_id: authData.user.id,
        _brand_name: brandName.trim(),
        _full_name: fullName.trim() || null,
      });

      if (setupError) throw setupError;
      const userID = authData?.user?.id || "";
      this.updateReservation("reservation", userID, signupEmail, signupPassword);
      return {};
      /*  toast({
          title: "Account created!",
          description: "Welcome to your AI restaurant receptionist dashboard.",
        });
        navigate("/"); */
    } catch (error) {
      hideLoader("registerreservation");
      /*  toast({
          title: "Signup failed",
          description: error.message,
          variant: "destructive",
        }); */
    } finally {
      hideLoader("registerreservation");
      /* setIsLoading(false); */
    }
  };

  handleEngageSignup = async () => {
    try {
      showLoader("registerEngage");
      //const fullName = this.state.clientdata.companyName;
      const signupEmail = this.state.clientdata.companyEmail;
      const signupPassword = this.generateRandomString(12);
      // Signup
      const { data: authData } = await epicengageSupabase.auth.signUp({
        email: signupEmail,
        password: signupPassword,
      });
      /* , error */
      const userID = authData?.user?.id || "";
      this.updateReservation("Engage", userID, signupEmail, signupPassword);
      console.log(authData, "authDataauthDataauthDataauthData");
      hideLoader("registerEngage");
    } catch (error) {
      hideLoader("registerEngage");
    } finally {
      hideLoader("registerEngage");
    }
  };

  handleEngagev1Signup = async () => {
    try {
      showLoader("registerEngagev1");
      //const fullName = this.state.clientdata.companyName;
      const signupEmail = this.state.clientdata.companyEmail;
      const signupPassword = this.generateRandomString(12);
      // Signup
      const { data: authData } = await epicengageSupabasev1.auth.signUp({
        email: signupEmail,
        password: signupPassword,
      });
      const userID = authData?.user?.id || "";
      const merchantId = crypto.randomUUID();
      const businessName = this.state.clientdata.companyName;
      const businessType = 'F&B';
      const region = "Singapore";
      const brandTone = 'Friendly & Casual';
      /* const { error: mErr } = */ await epicengageSupabasev1
        .from("merchants")
        .insert({
          id: merchantId,
          name: businessName,
          business_type: businessType,
          region,
          brand_tone: brandTone,
          sender_email: null,
          sender_domain: null,
          ses_verified: false,
        });
     /*  if (mErr) throw mErr; */

      await epicengageSupabasev1
        .from("user_merchants")
        .upsert({ user_id: userID, merchant_id: merchantId, role: "owner" }, { onConflict: "user_id,merchant_id" });

      /* const { error: cErr } = */ await epicengageSupabasev1.from("email_credits").insert({
        merchant_id: merchantId,
        plan_name: "Starter",
        credits_total: 500,
        credits_used: 0,
        reset_at: this.firstOfNextMonthISO(),
        overage_allowed: false,
      });
     

      /* , error */
      
      this.updateReservation("Engagev1", userID, signupEmail, signupPassword);
      console.log(authData, "authDataauthDataauthDataauthData");
      hideLoader("registerEngagev1");
    } catch (error) {
      hideLoader("registerEngagev1");
    } finally {
      hideLoader("registerEngagev1");
    }
  };


  handleEpicSocialSignup = async () => {
    try {
      showLoader("registerEpicSocial");
      //const fullName = this.state.clientdata.companyName;
      const signupEmail = this.state.clientdata.companyEmail;
      const signupPassword = this.generateRandomString(12);
      // Signup
      const { data: authData } = await supabaseEpicSocial.auth.signUp({
        email: signupEmail,
        password: signupPassword,
      });
      const userID = authData?.user?.id || "";
      
      this.updateReservation("EpicSocial", userID, signupEmail, signupPassword);
      console.log(authData, "authDataauthDataauthDataauthData");
      hideLoader("registerEpicSocial");
    } catch (error) {
      hideLoader("registerEpicSocial");
    } finally {
      hideLoader("registerEpicSocial");
    }
  };


  

  firstOfNextMonthISO = () => {
    const now = new Date();
    const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1, 0, 0, 0));
    return d.toISOString();
  };

  generateRandomString = (length = 10) => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return result;
  };

  updateReservation(type, userID, signupEmail, signupPassword) {
    let postObject = "";
    if (type === "reservation") {
      postObject = {
        companyEnableReservation: true,
        companysupabaseReservationID: userID,
        companysupabaseReservationUserName: signupEmail,
        companysupabaseReservationPassword: signupPassword,
      };
    } else if (type === "Engage") {
      postObject = {
        companyEnableEpicEngage: true,
        companysupabaseEngageID: userID,
        companysupabaseEngageUserName: signupEmail,
        companysupabaseEngagePassword: signupPassword,
      };
    } else if (type === "Engagev1") {
      postObject = {
        companyEnableEpicEngagev1: true,
        companysupabaseEngageIDv1: userID,
        companysupabaseEngagev1UserName: signupEmail,
        companysupabaseEngagev1Password: signupPassword,
      };
    } else if (type === "EpicSocial") {
      postObject = {
        companyEnableEpicSocial: true,
        companysupabaseEpicSocialID: userID,
        companysupabaseEpicSocialUserName: signupEmail,
        companysupabaseEpicSocialPassword: signupPassword,
      };
    }

    if (postObject !== "") {
      axios
        .post(`${apiUrl}company/updateReservation/${this.state.editID}`, postObject, masterheaderconfig)
        .then((res) => {
          hideLoader("registerreservation");
          if (res.data.status === "ok") {
            var params = {
              url: `${apiUrl}company/details/${this.state.editID}`,
              type: "master",
            };
            this.setState({ pageloading: true });
            this.props.getDetailData(params);
          }
          console.log(res.data, "res.datares.datares.data");
        })
        .catch((e) => {
          hideLoader("lalamovepricequote");
          console.log(e);
        });
    }
  }

  companycategoryList() {
    var urlShringTxt = apiUrl + "common/categoryList";

    axios
      .get(urlShringTxt, masterheaderconfig)
      .then((res) => {
        var categoryList = [];
        if (res.data.status === "ok") {
          categoryList = res.data.result;
        }
        this.setState({ categoryList: categoryList });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  loadCountyList() {
    var urlShringTxt = apiUrl + "common/countryList";

    axios
      .get(urlShringTxt, masterheaderconfig)
      .then((res) => {
        var countryList = [];
        if (res.data.status === "ok") {
          countryList = res.data.result;
        }
        this.setState({ countryList: countryList });
      })
      .catch((e) => {
        console.log(e);
      });
  }
  loadCurrency() {
    var urlShringTxt = apiUrl + "common/currencyList";

    axios.get(urlShringTxt, masterheaderconfig).then((res) => {
      var currencyList = [];
      if (res.data.status === "ok") {
        res.data.result.map((item) => {
          currencyList.push({
            label: item.currency_name,
            value: item.currency_name,
          });
          return "";
        });
      }
      this.setState({ currencyList: currencyList });
    });
  }

  loadLanguage() {
    var urlShringTxt = apiUrl + "common/languagesList";

    axios
      .get(urlShringTxt, masterheaderconfig)
      .then((res) => {
        var languageList = [];
        if (res.data.status === "ok") {
          res.data.result.map((item) =>
            languageList.push({
              label: item.language_name,
              value: item.language_code,
            }),
          );
        }
        this.setState({ languageList: languageList });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  loadAvailabilty() {
    var urlShringTxt = ecommerceapiUrl + "availability/dropDownList";
    axios
      .get(urlShringTxt, masterheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ availabiltyList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { clientdata: { [field]: { $set: value } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;
    let cate_idtxt = "";
    let categorylistvl = postData.companyCategoryID.length > 0 ? postData.companyCategoryID : [];
    if (categorylistvl !== undefined && Object.keys(categorylistvl).length > 0) {
      categorylistvl.map((valuetxt, index) => {
        cate_idtxt = index === 0 ? valuetxt.value : cate_idtxt + "~" + valuetxt.value;
        return "";
      });
    }

    const postObject = {
      companyName: postData.companyName,
      companyUsername: postData.companyUsername,
      companyPassword: postData.companyPassword,
      companyCPassword: postData.companyCPassword,
      companyEmail: postData.companyEmail,
      companyContactNumber: postData.companyContactNumber,
      companyWebSite: postData.companyWebSite,
      companyCountry: postData.companyCountry?.value ?? "",
      companyCategoryID: cate_idtxt,
      companyCurrency: postData.companyCurrency?.value ?? "",
      companyLanguage: postData.companyLanguage?.value ?? "",
      companyDateFormat: postData.companyDateFormat?.value ?? "",
      companyTimeFormat: postData.companyTimeFormat?.value ?? "",
      companyEarnPointPercentage: postData?.companyEarnPointPercentage ?? null,
      companyLogo: postData?.companyLogo ?? "",
      companyPlans: postData?.companyPlans.length > 0 ? postData.companyPlans.join(",") : "",
      companyAvailability: postData.companyAvailability.length > 0 ? postData.companyAvailability.join(",") : "",
      companyStatus: postData.companyStatus?.value ?? "I",
      companyLiveStatus: postData.companyLiveStatus ?? false,
      companyMerchantsType: postData.companyMerchantsType?.value ?? "1",
      companyEnableSubscription: postData?.companyEnableSubscription ?? false,
      companyEnableEmailCampaign: postData?.companyEnableEmailCampaign ?? false,
      companyEnableSMSCampaign: postData?.companyEnableSMSCampaign ?? false,
      companyTwilioFromName: postData?.companyTwilioFromName ?? "'",
      companyEnableWhatsappCampaign: postData?.companyEnableWhatsappCampaign ?? false,
      companyTwilioWhatsappSenderID: postData?.companyTwilioWhatsappSenderID ?? "",
      companyTwilioWhatsappTotalMsg: postData?.companyTwilioWhatsappTotalMsg ?? 0,
      companyTwilioWhatsappUsedMsg: postData?.companyTwilioWhatsappUsedMsg ?? 0,
      companyTwilioWhatsappAvailableMsg: postData?.companyTwilioWhatsappAvailableMsg ?? 0,
      companyTwilioWhatsappMsgTopup: postData?.companyTwilioWhatsappMsgTopup ?? 0,
      companyUniqueIDTxt: postData?.companyUniqueIDTxt ?? "",
      companyEnableTax: postData?.companyEnableTax ?? false,
      companySMSBalance: postData?.companySMSBalance ?? "",
      companyEnableMembership: postData?.companyEnableMembership ?? false,
      companyenablemanualpayment: postData?.companyenablemanualpayment ?? false,
      companyEnablemswipe: postData?.companyEnablemswipe ?? false,
      companymswipemode: postData?.companymswipemode ?? 0,
      companymswiperefid: postData?.companymswiperefid ?? "",
      companymswipecustCode: postData?.companymswipecustCode ?? "",
      companymswipeUserName: postData?.companymswipeUserName ?? "",
      companymswipeuserPasssword: postData?.companymswipeuserPasssword ?? "",
      companyenablereddot: postData?.companyenablereddot ?? false,
      companyreddotmodemv3ds: postData?.companyreddotmodemv3ds ?? false,
      companyreddotmidmv3ds: postData?.companyreddotmidmv3ds ?? "",
      companyreddotsecretKeymv3ds: postData?.companyreddotsecretKeymv3ds ?? "",
      companyreddotmodeamex3ds: postData?.companyreddotmodeamex3ds ?? false,
      companyreddotmidamex3ds: postData?.companyreddotmidamex3ds ?? "",
      companyreddotsecretKeyamex3ds: postData?.companyreddotsecretKeyamex3ds ?? "",
      companyreddotmodemvwithout3ds: postData?.companyreddotmodemvwithout3ds ?? false,
      companyreddotmidmvwithout3ds: postData?.companyreddotmidmvwithout3ds ?? "",
      companyreddotsecretKeymvwithout3ds: postData?.companyreddotsecretKeymvwithout3ds ?? "",
      companyreddotmodeamexwithout3ds: postData?.companyreddotmodeamexwithout3ds ?? false,
      companyreddotmidamexwithout3ds: postData?.companyreddotmidamexwithout3ds ?? "",
      companyreddotsecretKeyamexwithout3ds: postData?.companyreddotsecretKeyamexwithout3ds ?? "",
      companyreddotmodeapplepay: postData?.companyreddotmodeapplepay ?? false,
      companyreddotmidapplepay: postData?.companyreddotmidapplepay ?? "",
      companyreddotsecretKeyapplepay: postData?.companyreddotsecretKeyapplepay ?? "",
      companyreddotmodegooglepay: postData?.companyreddotmodegooglepay ?? false,
      companyreddotmidgooglepay: postData?.companyreddotmidgooglepay ?? "",
      companyreddotsecretKeygooglepay: postData?.companyreddotsecretKeygooglepay ?? "",
      companyreddotmodeatome: postData?.companyreddotmodeatome ?? false,
      companyreddotmidatome: postData?.companyreddotmidatome ?? "",
      companyreddotsecretKeyatome: postData?.companyreddotsecretKeyatome ?? "",
      companyreddotmodepaynow: postData?.companyreddotmodepaynow ?? false,
      companyreddotmidpaynow: postData?.companyreddotmidpaynow ?? "",
      companyreddotsecretKeypaynow: postData?.companyreddotsecretKeypaynow ?? "",
      companyreddotmodegrabpay: postData?.companyreddotmodegrabpay ?? false,
      companyreddotmidgrabpay: postData?.companyreddotmidgrabpay ?? "",
      companyreddotsecretKeygrabpay: postData?.companyreddotsecretKeygrabpay ?? "",
      companyEnableRapyd: postData?.companyEnableRapyd ?? false,
      companyrapydmode: postData?.companyrapydmode ?? false,
      companyrapydaccesskey: postData?.companyrapydaccesskey ?? "",
      companyrapydsecretkey: postData?.companyrapydsecretkey ?? "",
      companyEnableStripe: postData?.companyEnableStripe || false,
      companyStripeSecretKey: postData?.companyStripeSecretKey ?? "",
      companyStripePublicKey: postData?.companyStripePublicKey ?? "",

      companyEnableOmise: postData?.companyEnableOmise || false,
      companyEnableOmisePayNow: postData?.companyEnableOmisePayNow || false,
      companyOmiseSecretKey: postData?.companyOmiseSecretKey ?? "",
      companyOmisePublicKey: postData?.companyOmisePublicKey ?? "",

      companyTelegramchatID: postData?.companyTelegramchatID ?? "",
      companyAllowAssignVoucher: postData?.companyAllowAssignVoucher ?? false,
      companyEnableGoogleWallet: postData?.companyEnableGoogleWallet ?? false,
      companyEnableAppleWallet: postData?.companyEnableAppleWallet ?? false,

      companyEnableMenu: postData?.companyEnableMenu ?? false,
      companyEnableTAT: postData?.companyEnableTAT ?? false,
      companyEnableZoneValueBaseDeliveryCharge: postData?.companyEnableZoneValueBaseDeliveryCharge ?? false,
      companyEnableGuestCheckout: postData?.companyEnableGuestCheckout ?? false,
      companyEnableMaintenanceMode: postData?.companyEnableMaintenanceMode ?? false,
      companyEnableAdditionalCharge: postData?.companyEnableAdditionalCharge ?? false,

      companyEnableSpinWheel: postData?.companyEnableSpinWheel ?? false,
      companyEnableScratch: postData?.companyEnableScratch ?? false,
      companyEnablePromocode: postData?.companyEnablePromocode ?? false,
      companyEnableLoyalty: postData?.companyEnableLoyalty ?? false,
      companyEnableAscentisCRM: postData?.companyEnableAscentisCRM ?? false,
      companyEnableNewSignupPromocode: postData?.companyEnableNewSignupPromocode ?? false,
      companyEnableHoliday: postData?.companyEnableHoliday ?? false,
      companyEnableOrderCount: postData?.companyEnableOrderCount ?? false,
      companyEnableHighlightProduct: postData?.companyEnableHighlightProduct ?? false,
      companyEnableProductTimeAvailability: postData?.companyEnableProductTimeAvailability ?? false,
      companyEnableProductspecialDays: postData?.companyEnableProductspecialDays ?? false,
      companyEnableProductRating: postData?.companyEnableProductRating ?? false,
      companyEnableStock: postData?.companyEnableStock ?? false,

      companyEnableLalamove: postData?.companyEnableLalamove ?? false,
      companyLalamovemode: postData?.companyLalamovemode ?? false,
      companyLalamoveKey: postData?.companyLalamoveKey ?? "",
      companyLalamoveSecretKey: postData?.companyLalamoveSecretKey ?? "",
      companyLalamoveCountry: postData?.companyLalamoveCountry ?? "",
      companyLalamoveserviceType: postData?.companyLalamoveserviceType?.value || "",
      companyEnableDeliveryFeeAuto: postData?.companyEnableDeliveryFeeAuto ?? false,
      companyEnableDeliveryAutoCreate: postData?.companyEnableDeliveryAutoCreate ?? false,
      companyEnableReservation: postData?.companyEnableReservation ?? false,
      companyEnableEpicEngage: postData?.companyEnableEpicEngage ?? false,
      companyEnableEpicEngagev1: postData?.companyEnableEpicEngagev1 ?? false,
      companyEnableEpicSocial: postData?.companyEnableEpicSocial ?? false,
      companyEnableCatering: postData?.companyEnableCatering ?? false,
    };

    var post_url = "company";
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `company/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "master", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"client"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{this.state.editID !== "" ? "Update" : "Add New"} Client</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={"/masterpanel/client"}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <Form
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  sateValChange={this.sateValChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  categoryList={this.state.categoryList}
                  countryList={this.state.countryList}
                  currencyList={this.state.currencyList}
                  languageList={this.state.languageList}
                  availabiltyList={this.state.availabiltyList}
                  handleSignup={this.handleSignup.bind(this)}
                  handleEngageSignup={this.handleEngageSignup.bind(this)}
                  handleEngagev1Signup={this.handleEngagev1Signup.bind(this)}
                  handleEpicSocialSignup={this.handleEpicSocialSignup.bind(this)}
                  editID={this.state.editID}
                  onInvalid={() => {
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          500,
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
        {<PageLoader pageloading={this.state.pageloading} />}
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Clientform));

const isEmpty = (value) => (value === "" ? "This field is required." : null);
const minLength = (password, length) => (password.length >= length || password === "" ? null : `Password must be at least ${length} characters.`);

const areSame = (password, rePassword) => (password === rePassword ? null : "Password do not match.");
const isEmail = (email) => (validator.isEmail(email) ? null : "This is not a valid email.");

function validationConfig(props) {
  const { companyName, companyUsername, companyPassword, companyCPassword, companyEmail, companyStatus, companyMerchantsType } = props.fields;
  if (props.editID === "") {
    return {
      fields: ["companyName", "companyUsername", "companyPassword", "companyCPassword", "companyEmail", "companyStatus", "companyMerchantsType"],

      validations: {
        companyName: [[isEmpty, companyName]],
        companyUsername: [[isEmpty, companyUsername]],
        companyPassword: [
          [isEmpty, companyPassword],
          [minLength, companyPassword, 9],
          [passwordChar, companyPassword],
        ],
        companyCPassword: {
          rules: [
            [areSame, companyPassword, companyCPassword],
            [isEmpty, companyCPassword],
          ],
          fields: ["companyPassword", "companyCPassword"],
        },
        companyEmail: [
          [isEmpty, companyEmail],
          [isEmail, companyEmail],
        ],
        companyStatus: [[isSingleSelect, companyStatus]],
        companyMerchantsType: [[isSingleSelect, companyMerchantsType]],
      },
    };
  } else {
    return {
      fields: ["companyName", "companyUsername", "companyPassword", "companyCPassword", "companyEmail", "companyStatus", "companyMerchantsType"],

      validations: {
        companyName: [[isEmpty, companyName]],
        companyUsername: [[isEmpty, companyUsername]],
        companyPassword: [
          [minLength, companyPassword, 10],
          [passwordChar, companyPassword],
        ],
        companyCPassword: {
          rules: [[areSame, companyPassword, companyCPassword]],
          fields: ["companyPassword", "companyCPassword"],
        },
        companyEmail: [
          [isEmpty, companyEmail],
          [isEmail, companyEmail],
        ],
        companyStatus: [[isSingleSelect, companyStatus]],
        companyMerchantsType: [[isSingleSelect, companyMerchantsType]],
      },
    };
  }
}

class Form extends Component {
  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  handleChangeCheckBox(fieldName, e) {
    var selectedAvail = e.target.value;
    var stateValue = this.props.fields[fieldName];
    if (e.target.checked === true) {
      stateValue.push(e.target.value);
    } else {
      const indexNew = stateValue.indexOf(selectedAvail);
      stateValue.splice(indexNew, 1);
    }
    this.props.onChange(fieldName, stateValue);
  }

  async uplaodFiles(imageType) {
    this.props.sateValChange("btndisabled", true);
    showLoader("ImageDetails");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#" + imageType);
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "company", "master", "epcipay");
    if (fileDetail.status === "ok") {
      this.props.onChange(imageType, fileDetail.url);
    }
    hideLoader("ImageContainer");
    hideLoader("ImageDetails");
    $("#" + imageType).val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, imageType, e) {
    e.preventDefault();
    showLoader("ImageDetails", "class");
    var fileDetail = await removeFile(fileNamme, "master", "epcipay");
    if (fileDetail.status === "ok") {
      hideLoader("ImageDetails", "class");
      this.props.onChange(imageType, "");
    }
  }

  /*  async uplaodcompanyImage() {
    var imagefile = document.querySelector("#companyLogo");
    const file = imagefile.files[0];
    const params = {
      Bucket: bucketName,
      Key: `media/${foldername}/outlet/${file.name}`,
      Body: file,
      ACL: "public-read",
    };
    const { Location } = await s3.upload(params).promise();
    this.props.onChange("companyLogo", Location);
    $("#companyLogo").val("");
  }

  async removeImage(fileNamme, ImageType, event) {
    event.preventDefault();
    var imagePath = "";
    if (ImageType === "companyLogo") {
      imagePath = "outlet";
    }
    var fileNammeSplit = fileNamme.split("/");
    console.log(fileNammeSplit, "fileNammeSplit");
    var params = {
      Bucket: bucketName,
      Key: `media/${foldername}/${imagePath}/${
        fileNammeSplit[fileNammeSplit.length - 1]
      }`,
    };
    await s3.deleteObject(params).promise();
    this.props.onChange(ImageType, "");
  } */

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgName,
      errMsgUsername,
      errMsgPassword,
      errMsgConfirmPassword,
      errMssEmail,
      errMsgStatus,
      errMsgMerType = "";
    if ($validation.companyName.error.reason !== undefined) {
      errMsgName = $validation.companyName.show && <span className="error">{$validation.companyName.error.reason}</span>;
    }

    if ($validation.companyUsername.error.reason !== undefined) {
      errMsgUsername = $validation.companyUsername.show && <span className="error">{$validation.companyUsername.error.reason}</span>;
    }
    if ($validation.companyPassword.error.reason !== undefined) {
      errMsgPassword = $validation.companyPassword.show && <span className="error">{$validation.companyPassword.error.reason}</span>;
    }
    if ($validation.companyCPassword.error.reason !== undefined) {
      errMsgConfirmPassword = $validation.companyCPassword.show && <span className="error">{$validation.companyCPassword.error.reason}</span>;
    }
    if ($validation.companyEmail.error.reason !== undefined) {
      errMssEmail = $validation.companyEmail.show && <span className="error">{$validation.companyEmail.error.reason}</span>;
    }
    if ($validation.companyStatus.error.reason !== undefined) {
      errMsgStatus = $validation.companyStatus.show && <span className="error">{$validation.companyStatus.error.reason}</span>;
    }
    if ($validation.companyMerchantsType.error.reason !== undefined) {
      errMsgMerType = $validation.companyMerchantsType.show && <span className="error">{$validation.compancompanyMerchantsTypey_status.error.reason}</span>;
    }
    const reddotList = [
      { label: "Mastetr Visa Card With 3DS", key: "mv3ds" },
      { label: "Amex Card With 3DS", key: "amex3ds" },
      { label: "Mastetr Visa Card Without 3DS", key: "mvwithout3ds" },
      { label: "Amex Card Without 3DS", key: "amexwithout3ds" },
      { label: "ApplePay", key: "applepay" },
      { label: "GooglePay", key: "googlepay" },
      { label: "Atome", key: "atome" },
      { label: "PayNow", key: "paynow" },
      { label: "GrabPay", key: "grabpay" },
    ];

    return (
      <form className="card-body fv-plugins-bootstrap5" id="modulefrm">
        <div className="accordion mt-3 accordion-header-primary" id="accordionStyle1">
          <div className="accordion-item active">
            <h2 className="accordion-header">
              <button type="button" className="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-3" aria-expanded="true">
                Client Info
              </button>
            </h2>
            <div id="accordionStyle1-3" className="accordion-collapse collapse show" data-bs-parent="#accordionStyle1">
              <div className="accordion-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className={errMsgName !== "" && errMsgName !== false && errMsgName !== undefined ? "form-control is-invalid" : "form-control"}
                        name="companyName"
                        value={fields.companyName}
                        {...$field("companyName", (e) => onChange("companyName", e.target.value))}
                      />
                      <label htmlFor="companyName">
                        Client Name <span className="error">*</span>
                      </label>
                      {errMsgName}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className={errMsgUsername !== "" && errMsgUsername !== false && errMsgUsername !== undefined ? "form-control is-invalid" : "form-control"}
                        name="companyUsername"
                        value={fields.companyUsername}
                        {...$field("companyUsername", (e) => onChange("companyUsername", e.target.value))}
                        disabled={this.props.editID !== "" ? true : false}
                      />
                      <label htmlFor="companyUsername">
                        Username <span className="error">*</span>
                      </label>
                      {errMsgUsername}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-4 form-password-toggle">
                      <div className="input-group input-group-merge">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="password"
                            id="companyPassword"
                            className={errMsgPassword !== "" && errMsgPassword !== false && errMsgPassword !== undefined ? "form-control is-invalid" : "form-control"}
                            value={fields.companyPassword}
                            {...$field("companyPassword", (e) => onChange("companyPassword", e.target.value))}
                          />
                          <label htmlFor="companyPassword">Password</label>
                          {errMsgPassword}
                        </div>
                        <span className="input-group-text rounded-end cursor-pointer" id="basic-default-password4" style={{ height: "49px" }}>
                          <i className="mdi mdi-eye-off-outline"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-4 form-password-toggle">
                      <div className="input-group input-group-merge">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="password"
                            id="companyCPassword"
                            className={errMsgConfirmPassword !== "" && errMsgConfirmPassword !== false && errMsgConfirmPassword !== undefined ? "form-control is-invalid" : "form-control"}
                            value={fields.companyCPassword}
                            {...$field("companyCPassword", (e) => onChange("companyCPassword", e.target.value))}
                          />
                          <label htmlFor="companyCPassword">Confirm Password</label>
                          {errMsgConfirmPassword}
                        </div>
                        <span className="input-group-text rounded-end cursor-pointer" id="basic-default-password3" style={{ height: "49px" }}>
                          <i className="mdi mdi-eye-off-outline"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className={errMssEmail !== "" && errMssEmail !== false && errMssEmail !== undefined ? "form-control is-invalid" : "form-control"}
                        name="companyEmail"
                        id="companyEmail"
                        value={fields.companyEmail}
                        {...$field("companyEmail", (e) => onChange("companyEmail", e.target.value))}
                      />
                      <label htmlFor="companyEmail">
                        Email ID <span className="error">*</span>
                      </label>
                      {errMssEmail}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="companyContactNumber"
                        id="companyContactNumber"
                        value={fields.companyContactNumber}
                        {...$field("companyContactNumber", (e) => onChange("companyContactNumber", e.target.value))}
                      />
                      <label htmlFor="companyContactNumber">
                        Contact Number <span className="error">*</span>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="companyWebSite"
                        id="companyWebSite"
                        value={fields.companyWebSite}
                        {...$field("companyWebSite", (e) => onChange("companyWebSite", e.target.value))}
                      />
                      <label htmlFor="companyWebSite">
                        Web Site <span className="error">*</span>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 mt-4">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="EpicPay"
                        id="EpicPay"
                        onChange={this.handleChangeCheckBox.bind(this, "companyPlans")}
                        checked={fields.companyPlans.indexOf("EpicPay") >= 0 ? true : false}
                      />
                      <label class="form-check-label" htmlFor="EpicPay">
                        {" "}
                        EpicPay{" "}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="Ecommerce"
                        id="Ecommerce"
                        onChange={this.handleChangeCheckBox.bind(this, "companyPlans")}
                        checked={fields.companyPlans.indexOf("Ecommerce") >= 0 ? true : false}
                      />
                      <label class="form-check-label" htmlFor="Ecommerce">
                        {" "}
                        Ecommerce{" "}
                      </label>
                    </div>
                  </div>
                  {fields.companyPlans.indexOf("EpicPay") >= 0 && (
                    <div className="col-md-6 mt-4">
                      <div className="form-floating form-floating-outline custm-select-box">
                        <Select
                          value={fields.companyCategoryID}
                          onChange={this.handleSelectChange.bind(this, "companyCategoryID")}
                          inputProps={{ name: "companyCategoryID", autoComplete: "off", autoCorrect: "off", spellCheck: "off" }}
                          placeholder="Select Category"
                          isMulti={true}
                          options={this.props.categoryList}
                        />
                        <label className="select-box-label">Categories</label>
                      </div>
                    </div>
                  )}
                  <div className="col-md-3 mt-4">
                    <div className="form-floating form-floating-outline custm-select-box">
                      <Select value={fields.companyCountry} onChange={this.handleSelectChange.bind(this, "companyCountry")} placeholder="Select Country" options={this.props.countryList} />
                      <label className="select-box-label">Country</label>
                    </div>
                  </div>
                  <div className="col-md-3 mt-4">
                    <div className="form-floating form-floating-outline custm-select-box">
                      <Select value={fields.companyCurrency} onChange={this.handleSelectChange.bind(this, "companyCurrency")} placeholder="Select Currency" options={this.props.currencyList} />
                      <label className="select-box-label">Currency</label>
                    </div>
                  </div>
                  <div className="col-md-3 mt-4">
                    <div className="form-floating form-floating-outline custm-select-box">
                      <Select value={fields.companyLanguage} onChange={this.handleSelectChange.bind(this, "companyLanguage")} placeholder="Select Language" options={this.props.languageList} />
                      <label className="select-box-label">Language</label>
                    </div>
                  </div>
                  <div className="col-md-3 mt-4">
                    <div className="form-floating form-floating-outline custm-select-box">
                      <Select
                        value={fields.companyDateFormat}
                        onChange={this.handleSelectChange.bind(this, "companyDateFormat")}
                        placeholder="Select Date Format"
                        options={[
                          {
                            value: "LLLL d, yyyy",
                            label: format(todayDate, "LLLL d, yyyy"),
                          },
                          {
                            value: "yyyy-MM-dd",
                            label: format(todayDate, "yyyy-MM-dd"),
                          },
                          {
                            value: "MM/dd/yyyy",
                            label: format(todayDate, "MM/dd/yyyy"),
                          },
                          {
                            value: "MM/dd/yy",
                            label: format(todayDate, "MM/dd/yy"),
                          },
                          {
                            value: "dd/MM/yyyy",
                            label: format(todayDate, "dd/MM/yyyy"),
                          },
                          {
                            value: "dd-MM-yyyy",
                            label: format(todayDate, "dd-MM-yyyy"),
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="col-md-3 mt-4">
                    <div className="form-floating form-floating-outline custm-select-box">
                      <Select
                        value={fields.companyTimeFormat}
                        onChange={this.handleSelectChange.bind(this, "companyTimeFormat")}
                        placeholder="Select Time Format"
                        options={[
                          {
                            value: "hh:mm a",
                            label: format(todayDate, "hh:mm a"),
                          },
                          {
                            value: "HH:mm",
                            label: format(todayDate, "HH:mm"),
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className={errMsgMerType !== "" && errMsgMerType !== false && errMsgMerType !== undefined ? "col-md-3  mt-4 error-select error" : "col-md-3  mt-4"}>
                    <div className="form-floating form-floating-outline custm-select-box">
                      <Select
                        value={fields.companyMerchantsType}
                        onChange={this.handleSelectChange.bind(this, "companyMerchantsType")}
                        placeholder="Select Merchants Type"
                        options={[
                          { value: "2", label: "Voucher Only" },
                          { value: "1", label: "Complete " },
                        ]}
                      />
                      <label className="select-box-label">
                        Merchants Type<span className="error">*</span>
                      </label>
                      {errMsgMerType}
                    </div>
                  </div>
                  <div className="col-md-3" style={{ marginTop: "31px" }}>
                    <div className="form-floating form-floating-outline">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyLiveStatus")}
                        checked={fields.companyLiveStatus}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Go to Live For EpicPay</span>
                    </div>
                  </div>
                  <div className="col-md-3 mt-4">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="companyEarnPointPercentage"
                        id="companyEarnPointPercentage"
                        value={fields.companyEarnPointPercentage}
                        {...$field("companyEarnPointPercentage", (e) => onChange("companyEarnPointPercentage", e.target.value))}
                      />
                      <label htmlFor="companyEarnPointPercentage">Earn EpicPay Points Percentage</label>
                    </div>
                  </div>
                  <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-3 mt-4 error-select error" : "col-md-3 mt-4"}>
                    <div className="form-floating form-floating-outline custm-select-box">
                      <Select
                        value={fields.companyStatus}
                        onChange={this.handleSelectChange.bind(this, "companyStatus")}
                        placeholder="Select Status"
                        options={[
                          { value: "A", label: "Active" },
                          { value: "I", label: "Inactive" },
                        ]}
                      />
                      <label className="select-box-label">
                        Status<span className="error">*</span>
                      </label>
                      {errMsgStatus}
                    </div>
                  </div>
                </div>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <div className="mb-3" id="ImageContainer">
                        <label htmlFor="formFile" className="form-label">
                          Company Image
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          id="companyLogo"
                          onChange={(event) => {
                            this.uplaodFiles("companyLogo", event);
                            return false;
                          }}
                        />
                        For Recommendation Size : <b>200px X 200px</b>
                        <br />
                        To resize image:{" "}
                        <b>
                          <a href="https://imageresizer.com" target="_blank" rel="noreferrer">
                            click here
                          </a>
                        </b>
                      </div>
                    </div>
                    {fields.companyLogo !== "" && (
                      <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                        <div className="dz-details" id="ImageDetails">
                          <div className="dz-thumbnail">
                            <img alt="" src={fields.companyLogo} />
                          </div>
                        </div>
                        <a className="dz-remove" href="/" onClick={this.removeImage.bind(this, fields.companyLogo, "companyLogo")}>
                          Remove file
                        </a>
                      </div>
                    )}
                  </div>
                </div>
                {fields.companyPlans.indexOf("Ecommerce") >= 0 && (
                  <div className="row g-3">
                    <div className="col-md-12">
                      <h1 className="display-6 mb-0 mt-4">
                        Availability<span className="error">*</span>
                      </h1>
                      <div className="row">
                        {this.props.availabiltyList.length > 0 &&
                          this.props.availabiltyList.map((item, index) => {
                            return (
                              <div className="col-md-2" key={index}>
                                <div className="form-check mt-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value={item.availabilityID}
                                    id={"avail_" + index}
                                    checked={fields.companyAvailability.indexOf(item.availabilityID) >= 0 ? true : false}
                                    onChange={this.handleChangeCheckBox.bind(this, "companyAvailability")}
                                  />
                                  <label className="form-check-label" htmlFor={"avail_" + index}>
                                    {item.availabilityName}
                                  </label>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-1" aria-expanded="false">
                Basic Settings
              </button>
            </h2>

            <div id="accordionStyle1-1" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <div className="accordion-body">
                {fields.companyPlans.indexOf("EpicPay") >= 0 && (
                  <div className="row g-3">
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableSubscription")}
                          checked={fields.companyEnableSubscription}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Subscription</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableEmailCampaign")}
                          checked={fields.companyEnableEmailCampaign}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Email Campaign</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableSMSCampaign")}
                          checked={fields.companyEnableSMSCampaign}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable SMS Campaign</span>
                      </div>
                    </div>
                    {fields.companyEnableSMSCampaign === true && (
                      <div className="col-md-2">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyTwilioFromName"
                            id="companyTwilioFromName"
                            value={fields.companyTwilioFromName}
                            {...$field("companyTwilioFromName", (e) => onChange("companyTwilioFromName", e.target.value))}
                          />
                          <label htmlFor="companyTwilioFromName">SMS From Name</label>
                        </div>
                      </div>
                    )}
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyTelegramchatID"
                          id="companyTelegramchatID"
                          value={fields.companyTelegramchatID}
                          {...$field("companyTelegramchatID", (e) => onChange("companyTelegramchatID", e.target.value))}
                        />
                        <label htmlFor="companyEmail">Telegram Chat ID</label>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyAllowAssignVoucher")}
                          checked={fields.companyAllowAssignVoucher}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Allow to assign voucher to customer</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableGoogleWallet")}
                          checked={fields.companyEnableGoogleWallet}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Google Wallet</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableAppleWallet")}
                          checked={fields.companyEnableAppleWallet}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Apple Wallet</span>
                      </div>
                    </div>
                  </div>
                )}
                {fields.companyPlans.indexOf("Ecommerce") >= 0 && (
                  <div className="row g-3">
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableMenu")}
                          checked={fields.companyEnableMenu}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Menu</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableTAT")}
                          checked={fields.companyEnableTAT}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable TAT Time</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableZoneValueBaseDeliveryCharge")}
                          checked={fields.companyEnableZoneValueBaseDeliveryCharge}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Zone Order Value Base Delivery Charge</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableGuestCheckout")}
                          checked={fields.companyEnableGuestCheckout}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Guest Checkout</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableMaintenanceMode")}
                          checked={fields.companyEnableMaintenanceMode}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Maintenance Mode</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableAdditionalCharge")}
                          checked={fields.companyEnableAdditionalCharge}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Additional Charges</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableCatering")}
                          checked={fields.companyEnableCatering}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Catering</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableReservation")}
                          checked={fields.companyEnableReservation}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Reservation</span>
                      </div>
                    </div>
                    {fields.companyEnableReservation && fields.companysupabaseReservationID === "" && this.props.editID !== "" && (
                      <div className="col-md-3">
                        <button type="button" class="btn btn-primary me-sm-3 me-1 waves-effect waves-light" id="registerreservation" onClick={this.props.handleSignup.bind(this)}>
                          Register Reservation
                        </button>
                      </div>
                    )}
                  </div>
                )}
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableEpicEngage")}
                        checked={fields.companyEnableEpicEngage}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Engage Plan</span>
                    </div>
                  </div>
                  {fields.companyEnableEpicEngage && fields.companysupabaseEngageID === "" && this.props.editID !== "" && (
                    <div className="col-md-3">
                      <button type="button" class="btn btn-primary me-sm-3 me-1 waves-effect waves-light" id="registerEngage" onClick={this.props.handleEngageSignup.bind(this)}>
                        Register Engage Plan
                      </button>
                    </div>
                  )}
                </div>
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableEpicEngagev1")}
                        checked={fields.companyEnableEpicEngagev1}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Engage Plan V1</span>
                    </div>
                  </div>
                  {fields.companyEnableEpicEngagev1 && fields.companysupabaseEngageIDv1 === "" && this.props.editID !== "" && (
                    <div className="col-md-3">
                      <button type="button" class="btn btn-primary me-sm-3 me-1 waves-effect waves-light" id="registerEngagev1" onClick={this.props.handleEngagev1Signup.bind(this)}>
                        Register Engage Plan V1
                      </button>
                    </div>
                  )}
                </div>

                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableEpicSocial")}
                        checked={fields.companyEnableEpicSocial}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable EpicSocial</span>
                    </div>
                  </div>
                  {fields.companyEnableEpicSocial && fields.companysupabaseEpicSocialID === "" && this.props.editID !== "" && (
                    <div className="col-md-3">
                      <button type="button" class="btn btn-primary me-sm-3 me-1 waves-effect waves-light" id="registerEpicSocial" onClick={this.props.handleEpicSocialSignup.bind(this)}>
                        Register Engage EpicSocial
                      </button>
                    </div>
                  )}
                </div>

                <div className="col-md-3">
                  <div className="form-floating form-floating-outline mb-4">
                    <Switch
                      onChange={this.handleChange.bind(this, "companyEnableSpinWheel")}
                      checked={fields.companyEnableSpinWheel}
                      onColor="#666cff"
                      className="react-switch"
                      onHandleColor="#bdbfff"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    />
                    <span>Enable Spin Wheel</span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-floating form-floating-outline mb-4">
                    <Switch
                      onChange={this.handleChange.bind(this, "companyEnableScratch")}
                      checked={fields.companyEnableScratch}
                      onColor="#666cff"
                      className="react-switch"
                      onHandleColor="#bdbfff"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    />
                    <span>Enable Scratch Card</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {fields.companyPlans.indexOf("Ecommerce") >= 0 && (
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-2" aria-expanded="false">
                  Promotion Settings
                </button>
              </h2>
              <div id="accordionStyle1-2" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnablePromocode")}
                          checked={fields.companyEnablePromocode}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Promocode</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableNewSignupPromocode")}
                          checked={fields.companyEnableNewSignupPromocode}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable New Signup Promocode</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {fields.companyPlans.indexOf("Ecommerce") >= 0 && (
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-loyalty" aria-expanded="false">
                  Loyalty Settings
                </button>
              </h2>
              <div id="accordionStyle1-loyalty" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableLoyalty")}
                          checked={fields.companyEnableLoyalty}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Ecommerce Loyalty</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableAscentisCRM")}
                          checked={fields.companyEnableAscentisCRM}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Ascentis CRM</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {fields.companyPlans.indexOf("Ecommerce") >= 0 && (
            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordiontime" aria-expanded="false">
                  Time Settings
                </button>
              </h2>

              <div id="accordiontime" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableHoliday")}
                          checked={fields.companyEnableHoliday}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Holiday</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableOrderCount")}
                          checked={fields.companyEnableOrderCount}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Order Count</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {fields.companyPlans.indexOf("Ecommerce") >= 0 && (
            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionproduct" aria-expanded="false">
                  Product Settings
                </button>
              </h2>

              <div id="accordionproduct" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableHighlightProduct")}
                          checked={fields.companyEnableHighlightProduct}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Highlight Product</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableProductTimeAvailability")}
                          checked={fields.companyEnableProductTimeAvailability}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Product Time Availability</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableProductspecialDays")}
                          checked={fields.companyEnableProductspecialDays}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Product Special Days</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableProductRating")}
                          checked={fields.companyEnableProductRating}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Product Rating</span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChange.bind(this, "companyEnableStock")}
                          checked={fields.companyEnableStock}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Stock</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordiontax" aria-expanded="false">
                Tax Settings
              </button>
            </h2>

            <div id="accordiontax" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <div className="accordion-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableTax")}
                        checked={fields.companyEnableTax}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Tax</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionsms" aria-expanded="false">
                SMS Settings
              </button>
            </h2>

            <div id="accordionsms" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <div className="accordion-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="companySMSBalance"
                        id="companySMSBalance"
                        value={fields.companySMSBalance}
                        {...$field("companySMSBalance", (e) => onChange("companySMSBalance", e.target.value))}
                      />
                      <label htmlFor="companySMSBalance">SMS Count / Period</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionpayment" aria-expanded="false">
                Membership Settings
              </button>
            </h2>

            <div id="accordionpayment" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <div className="accordion-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableMembership")}
                        checked={fields.companyEnableMembership}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Membership</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#whatsappCampaign" aria-expanded="false">
                Whatsapp Settings
              </button>
            </h2>

            <div id="whatsappCampaign" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <div className="accordion-body">
                <div className="row g-12">
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableWhatsappCampaign")}
                        checked={fields.companyEnableWhatsappCampaign}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Whatsapp Campaign</span>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="companyTwilioWhatsappSenderID"
                        id="companyTwilioWhatsappSenderID"
                        value={fields.companyTwilioWhatsappSenderID}
                        {...$field("companyTwilioWhatsappSenderID", (e) => onChange("companyTwilioWhatsappSenderID", e.target.value))}
                      />
                      <label htmlFor="companyEmail">Twilio Whatsapp Sender ID</label>
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        disabled="disabled"
                        className="form-control"
                        name="companyTwilioWhatsappAvailableMsg"
                        id="companyTwilioWhatsappAvailableMsg"
                        value={fields.companyTwilioWhatsappAvailableMsg}
                        {...$field("companyTwilioWhatsappAvailableMsg", (e) => onChange("companyTwilioWhatsappAvailableMsg", e.target.value))}
                      />
                      <label htmlFor="companyEmail">Available Msg Count</label>
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="companyTwilioWhatsappMsgTopup"
                        id="companyTwilioWhatsappMsgTopup"
                        value={fields.companyTwilioWhatsappMsgTopup}
                        {...$field("companyTwilioWhatsappMsgTopup", (e) => onChange("companyTwilioWhatsappMsgTopup", e.target.value))}
                      />
                      <label htmlFor="companyEmail">TopupMsgCount(Now)</label>
                    </div>
                  </div>

                  {fields.companyTwilioWhatsappMsgLastTopup > 0 && (
                    <p className="lasttopup_info">
                      Last Topup At : {fields.companyTwilioWhatsappMsgLastTopupDate}, Last Topup Msg Count : {fields.companyTwilioWhatsappMsgLastTopup}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionmembership" aria-expanded="false">
                Payment Settings
              </button>
            </h2>
            <div id="accordionmembership" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <div className="accordion-body">
                <div className="row g-3">
                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyenablemanualpayment")}
                        checked={fields.companyenablemanualpayment}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Manual Payment</span>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnablemswipe")}
                        checked={fields.companyEnablemswipe}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable MSwipe</span>
                    </div>
                  </div>
                  {fields.companyEnablemswipe === true && (
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-floating form-floating-outline mb-4">
                          <Switch
                            onChange={this.handleChange.bind(this, "companymswipemode")}
                            checked={fields.companymswipemode}
                            onColor="#666cff"
                            className="react-switch"
                            onHandleColor="#bdbfff"
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          />
                          <span>Mode</span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companymswiperefid"
                            id="companymswiperefid"
                            value={fields.companymswiperefid}
                            {...$field("companymswiperefid", (e) => onChange("companymswiperefid", e.target.value))}
                          />
                          <label htmlFor="companymswiperefid">Ref ID</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companymswipecustCode"
                            id="companymswipecustCode"
                            value={fields.companymswipecustCode}
                            {...$field("companymswipecustCode", (e) => onChange("companymswipecustCode", e.target.value))}
                          />
                          <label htmlFor="companymswipecustCode">Customer Code</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companymswipeUserName"
                            id="companymswipeUserName"
                            value={fields.companymswipeUserName}
                            {...$field("companymswipeUserName", (e) => onChange("companymswipeUserName", e.target.value))}
                          />
                          <label htmlFor="companymswipeUserName">Username</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="password"
                            className="form-control"
                            name="companymswipeuserPasssword"
                            id="companymswipeuserPasssword"
                            value={fields.companymswipeuserPasssword}
                            {...$field("companymswipeuserPasssword", (e) => onChange("companymswipeuserPasssword", e.target.value))}
                          />
                          <label htmlFor="companymswipeuserPasssword">Password</label>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyenablereddot")}
                        checked={fields.companyenablereddot}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Reddot</span>
                    </div>
                  </div>
                  {fields.companyenablereddot === true && (
                    <div>
                      {reddotList.length > 0 &&
                        reddotList.map((item, index) => {
                          return (
                            <div key={index}>
                              <h4>{item.label}</h4>
                              <div className="row">
                                <div className="col-md-2">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <Switch
                                      onChange={this.handleChange.bind(this, `companyreddotmode${item.key}`)}
                                      checked={fields[`companyreddotmode${item.key}`]}
                                      onColor="#666cff"
                                      className="react-switch"
                                      onHandleColor="#bdbfff"
                                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    />

                                    <span>{fields[`companyreddotmode${item.key}`] === true ? "Live" : "Sandbox"}</span>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name={`companyreddotmid${item.key}`}
                                      id={`companyreddotmid${item.key}`}
                                      value={fields[`companyreddotmid${item.key}`]}
                                      {...$field(`companyreddotmid${item.key}`, (e) => onChange(`companyreddotmid${item.key}`, e.target.value))}
                                    />
                                    <label htmlFor={`companyreddotmid${item.key}`}>MID</label>
                                  </div>
                                </div>
                                <div className="col-md-5">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name={`companyreddotsecretKey${item.key}`}
                                      id={`companyreddotsecretKey${item.key}`}
                                      value={fields[`companyreddotsecretKey${item.key}`]}
                                      {...$field(`companyreddotsecretKey${item.key}`, (e) => onChange(`companyreddotsecretKey${item.key}`, e.target.value))}
                                    />
                                    <label htmlFor={`companyreddotsecretKey${item.key}`}>Secret Key</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  )}

                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableRapyd")}
                        checked={fields.companyEnableRapyd}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Rapyd</span>
                    </div>
                  </div>
                  {fields.companyEnableRapyd === true && (
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-floating form-floating-outline mb-4">
                          <Switch
                            onChange={this.handleChange.bind(this, "companyrapydmode")}
                            checked={fields.companyrapydmode}
                            onColor="#666cff"
                            className="react-switch"
                            onHandleColor="#bdbfff"
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          />
                          <span>Mode</span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyrapydaccesskey"
                            id="companyrapydaccesskey"
                            value={fields.companyrapydaccesskey}
                            {...$field("companyrapydaccesskey", (e) => onChange("companyrapydaccesskey", e.target.value))}
                          />
                          <label htmlFor="companyrapydaccesskey">Access Key</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyrapydsecretkey"
                            id="companyrapydsecretkey"
                            value={fields.companyrapydsecretkey}
                            {...$field("companyrapydsecretkey", (e) => onChange("companyrapydsecretkey", e.target.value))}
                          />
                          <label htmlFor="companyrapydsecretkey">Secret Key</label>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableStripe")}
                        checked={fields.companyEnableStripe}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Stripe</span>
                    </div>
                  </div>
                  {fields.companyEnableStripe === true && (
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyStripeSecretKey"
                            id="companyStripeSecretKey"
                            value={fields.companyStripeSecretKey}
                            {...$field("companyStripeSecretKey", (e) => onChange("companyStripeSecretKey", e.target.value))}
                          />
                          <label htmlFor="companyStripeSecretKey">Secret Key</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyStripePublicKey"
                            id="companyStripePublicKey"
                            value={fields.companyStripePublicKey}
                            {...$field("companyStripePublicKey", (e) => onChange("companyStripePublicKey", e.target.value))}
                          />
                          <label htmlFor="companyStripePublicKey">Public Key</label>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <Switch
                            onChange={this.handleChange.bind(this, "companyEnableOmise")}
                            checked={fields.companyEnableOmise}
                            onColor="#666cff"
                            className="react-switch"
                            onHandleColor="#bdbfff"
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          />
                          <span>Enable Omise(Card)</span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <Switch
                            onChange={this.handleChange.bind(this, "companyEnableOmisePayNow")}
                            checked={fields.companyEnableOmisePayNow}
                            onColor="#666cff"
                            className="react-switch"
                            onHandleColor="#bdbfff"
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          />
                          <span>Enable Omise(PayNow)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {(fields.companyEnableOmise === true || fields.companyEnableOmisePayNow === true) && (
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyOmiseSecretKey"
                            id="companyOmiseSecretKey"
                            value={fields.companyOmiseSecretKey}
                            {...$field("companyOmiseSecretKey", (e) => onChange("companyOmiseSecretKey", e.target.value))}
                          />
                          <label htmlFor="companyOmiseSecretKey">Secret Key</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyOmisePublicKey"
                            id="companyOmisePublicKey"
                            value={fields.companyOmisePublicKey}
                            {...$field("companyOmisePublicKey", (e) => onChange("companyOmisePublicKey", e.target.value))}
                          />
                          <label htmlFor="companyOmisePublicKey">Public Key</label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="accordion-item ">
            <h2 className="accordion-header">
              <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordiondelivery" aria-expanded="false">
                Delivery Settings
              </button>
            </h2>
            <div id="accordiondelivery" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <div className="accordion-body">
                <div className="row g-3">
                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableDeliveryAutoCreate")}
                        checked={fields.companyEnableDeliveryAutoCreate}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Delivery Auto Create</span>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableDeliveryFeeAuto")}
                        checked={fields.companyEnableDeliveryFeeAuto}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Delivery Fee Auto</span>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-4">
                      <Switch
                        onChange={this.handleChange.bind(this, "companyEnableLalamove")}
                        checked={fields.companyEnableLalamove}
                        onColor="#666cff"
                        className="react-switch"
                        onHandleColor="#bdbfff"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <span>Enable Lalamove</span>
                    </div>
                  </div>
                  {fields.companyEnableLalamove === true && (
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-floating form-floating-outline mb-4">
                          <Switch
                            onChange={this.handleChange.bind(this, "companyLalamovemode")}
                            checked={fields.companyLalamovemode}
                            onColor="#666cff"
                            className="react-switch"
                            onHandleColor="#bdbfff"
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          />
                          <span>Mode</span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyLalamoveKey"
                            id="companyLalamoveKey"
                            value={fields.companyLalamoveKey}
                            {...$field("companyLalamoveKey", (e) => onChange("companyLalamoveKey", e.target.value))}
                          />
                          <label htmlFor="companyLalamoveKey">API Key</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyLalamoveSecretKey"
                            id="companyLalamoveSecretKey"
                            value={fields.companyLalamoveSecretKey}
                            {...$field("companyLalamoveSecretKey", (e) => onChange("companyLalamoveSecretKey", e.target.value))}
                          />
                          <label htmlFor="companyLalamoveSecretKey">Secret Key</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyLalamoveCountry"
                            id="companyLalamoveCountry"
                            value={fields.companyLalamoveCountry}
                            {...$field("companyLalamoveCountry", (e) => onChange("companyLalamoveCountry", e.target.value))}
                          />
                          <label htmlFor="companyLalamoveCountry">Country Code</label>
                        </div>
                      </div>
                      <div className="col-md-3 mt-4">
                        <div className="form-floating form-floating-outline custm-select-box">
                          <Select
                            value={fields.companyLalamoveserviceType}
                            onChange={this.handleSelectChange.bind(this, "companyLalamoveserviceType")}
                            inputProps={{ name: "companyLalamoveserviceType", autoComplete: "off", autoCorrect: "off", spellCheck: "off" }}
                            placeholder="Select Service Type"
                            options={[
                              { label: "MOTORCYCLE", value: "MOTORCYCLE" },
                              { label: "CAR", value: "CAR" },
                            ]}
                          />
                          <label className="select-box-label">Service Type</label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-4 text-end">
          <button
            type="button"
            disabled={this.props.btndisabled}
            className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
            onClick={(e) => {
              e.preventDefault();
              if (!this.props.btndisabled) {
                this.props.$submit(onValid, onInvalid);
              }
            }}
          >
            Submit
          </button>
          <Link to={"/masterpanel/client"}>
            <button type="reset" className="btn btn-label-secondary waves-effect">
              Cancel
            </button>
          </Link>
        </div>
      </form>
    );
  }
}
Form = validated(validationConfig)(Form);
